<template>
  <img
    alt="How it works tablet"
    :src="tabletImage"
  >
</template>

<script>
// Images
import howItWorksTablet from '@/assets/images/nlp/howItWorksTablet.png'

export default {
  name: 'NlpHowItWorksImageTablet',
  computed: {
    tabletImage() {
      return howItWorksTablet
    },
  }
}
</script>

<style scoped>
img {
  max-width: 100%;
}
</style>